import React, { useState, useEffect } from 'react';
import { Container } from '../ui/Container';
import { CONFIG } from '../../Constants/Packages';
import { getImagePath } from '../../Utils/Utilities';
import { useIsMobile } from '../../Hooks/useIsMobile';

const testimonialData = [
  {
    name: "Ramlah Ghadiali",
    company: "Taheri Enterprises",
    location: "Mumbai, Maharashtra",
    comment: "I Have used various CRM but this is the most convenient and easy app to use, also at extremely reasonable rates."
  },
  {
    name: "Mr. Shri Shankar",
    company: "Solar Power Tech Solutions",
    location: "Coimbatore, Tamil Nadu",
    comment: "The quick response to my query was amazing. Overall I will rate you 100% satisfied with the ERP tools."
  },
  {
    name: "Mr. Nilesh Ahirrao",
    company: "Aneesh Associates",
    location: "Nashik, Maharashtra",
    comment: "Really appreciate the quick response to the request. Technical support is very friendly, patient, and helpful."
  },
  {
    name: "SP Sharma",
    company: "Creative Tools",
    location: "Noida, Uttar Pradesh",
    comment: "Using Biziverse CRM+ERP. Excellent software, also staff employees have good knowledge. Prompt in solving the issues."
  }
];

const TestimonialsSection = ({ brandLogo = getImagePath('/Images/QikERP.png') }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const isMobile = useIsMobile()

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonialData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swiped left
      setCurrentIndex((prev) => (prev + 1) % testimonialData.length);
    }
    if (touchStart - touchEnd < -50) {
      // Swiped right
      setCurrentIndex((prev) => (prev - 1 + testimonialData.length) % testimonialData.length);
    }
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonialData.length) % testimonialData.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonialData.length);
  };

  const googleReviews = [
    {
      comment: "I recommend Biziverse software for its economical price and awesome features. It's the lowest-priced, worthwhile CRM and accounting software I've encountered.",
      name: "Bharadwaj Reddy",
      company: "MARVEL INDIA CORPORATION",
      location: "Hyderabad, Telangana"
    },
    {
      comment: "Very useful software for managing business. Easy to use and the support team is always helpful and responsive.",
      name: "Rakesh Gupta",
      company: "Gupta Traders",
      location: "Delhi"
    },
    {
      comment: "Best ERP software at this price point. Covers everything from billing to inventory. Highly recommended for SMEs.",
      name: "Priya Mehta",
      company: "Mehta Industries",
      location: "Ahmedabad, Gujarat"
    }
  ];

  const [googleIndex, setGoogleIndex] = useState(0);
  const [googleVisible, setGoogleVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setGoogleVisible(false);
      setTimeout(() => {
        setGoogleIndex((prev) => (prev + 1) % googleReviews.length);
        setGoogleVisible(true);
      }, 400);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return (
    <section id="testimonials" className={`${!isMobile ? 'bg-white' : 'bg-background-light'} py-12 md:py-16 border-top lg:py-20`}>
      <Container>
        <div className="text-center">
          {/* Header */}
          <h2 className="mb-4">
            <div className="flex justify-center mb-4">
              <img
                src={brandLogo}
                alt={CONFIG.bzPrdName}
                className={`${brandLogo.includes('Biziverse.png') ? 'h-14' : 'h-28'}  object-contain`}
              />
            </div>
            <span className="block text-2xl md:text-2xl font-medium text-text-primary mb-4">
              Trusted by
            </span>
            <span className="block text-5xl md:text-6xl lg:text-7xl font-extrabold text-primary tracking-tight">
              {CONFIG.cntCstrsStr}+
            </span>
            <span className="block text-xl md:text-2xl font-medium text-text-primary mt-4">
              Businesses across India
            </span>
          </h2>

          <p className="text-base md:text-lg text-text-secondary font-semibold mb-8 md:mb-12 px-4 leading-relaxed">
            Manufacturers <span className="text-primary mx-2">•</span> Traders
            <br className="md:hidden" />
            <span className="hidden md:inline"><span className="text-primary mx-2">•</span></span>
            Retailers <span className="text-primary mx-2">•</span> Service Providers
          </p>

          {/* Testimonial Slider */}
          <div className="relative mb-8">

            {/* Mobile View - Horizontal Scroll Cards */}
            <div className="md:hidden">
              <div
                className="flex overflow-x-auto gap-4 px-4 pb-4 snap-x snap-mandatory scrollbar-hide"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {testimonialData.map((testimonial, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 w-[90%] snap-start bg-white p-5 text-left flex flex-col justify-between overflow-hidden"
                    style={{ minHeight: '220px', borderRadius: '5px', boxShadow: '0 3px 5px rgba(0,0,0,0.1)' }}
                  >
                    <div>
                      <div className="text-primary text-[14px] mb-3">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                      </div>
                      <p className="text-sm leading-5 text-text-primary">
                        {testimonial.comment}
                      </p>
                    </div>
                    <div className="mt-4">
                      <strong className="block text-sm font-bold text-text-primary">{testimonial.name}</strong>
                      <span className="text-xs text-text-secondary">
                        {testimonial.company}<br />
                        ({testimonial.location})
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop View - 3 Testimonials in a Row */}
            <div className="hidden md:block">
              <div className="grid grid-cols-3 gap-6 px-4">
                {[0, 1, 2].map((offset) => {
                  const index = (currentIndex + offset) % testimonialData.length;
                  const testimonial = testimonialData[index];
                  return (
                    <div
                      key={offset}
                      className="bg-[#f5f5f5] p-6 text-center transition-all duration-500 overflow-hidden"
                      style={{ borderRadius: '5px', boxShadow: '0 3px 5px rgba(0,0,0,0.1)' }}
                    >
                      <div className="text-primary text-xs mb-4">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                        <i className="fas fa-star ml-0.5"></i>
                      </div>
                      <p className="text-sm leading-relaxed text-text-primary mb-6 min-h-[80px]">
                        {testimonial.comment}
                      </p>
                      <div className="mt-auto">
                        <h4 className="font-bold text-text-primary text-base mb-1">{testimonial.name}</h4>
                        <p className="text-xs text-text-secondary">
                          {testimonial.company}<br />
                          <span className="text-text-light">({testimonial.location})</span>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>



          {/* Google Reviews Section - MOBILE ONLY */}
          <div className="md:hidden">
            <img src={getImagePath("/Images/GoogleRating.png")} className="w-[80%] mx-auto" />

            {/* Google Review Quote - Animated */}
            
          </div>

          {/* Desktop View - Dots + old style (no Google section) */}
          <div className="hidden md:block">
            <div className="flex justify-center gap-2.5">
              {testimonialData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-colors duration-300 ${index === currentIndex ? 'bg-primary' : 'bg-gray-300'}`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>


        </div>
      </Container>
    </section >
  );
};

export default TestimonialsSection;